import * as loaders from "loaders/legacy/legacy-objFileLoader";
export { loaders };
export default loaders;
